import common from "./common.js";
const api = {
  ...common,
};

export default api;
